import { Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useUserContext } from '../hooks/useUserContext';
import { config } from '../config';
import IndividualBillingManagement from './IndividualBillingManagement';

// Billing Route — org members should never see individual billing; their subscription is managed by their organization
export default function BillingRoute() {
  const { isTenantAdmin, isAdmin, backendProfile } = useUserContext();
  const isOrgMember = !!backendProfile?.tenantId && backendProfile.tenantId !== config.defaultTenantId;

  if (isTenantAdmin || isAdmin) {
    return <Navigate to="/app/tenant-admin/billing" replace />;
  }
  if (isOrgMember) {
    return (
      <Box sx={{ maxWidth: 600, mx: 'auto', mt: 8, textAlign: 'center' }}>
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Billing is managed by your organization
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Your subscription is handled by your organization's administrator.
          If you have questions about your account, please contact your admin.
        </Typography>
      </Box>
    );
  }
  return <IndividualBillingManagement />;
}
